import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ModalName, ModalService } from '../services/modal.service';
import { StoreIdService } from '../services/store-id.service';

export const registerGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const modalService = inject(ModalService);
  const authService = inject(AuthService);
  const storeIdService = inject(StoreIdService);

  return toObservable(authService.state).pipe(
    filter((value) => !value?.account?.dummy),
    map((value) => {
      router.navigate(storeIdService.getRoutePathSegments(['menu']), { queryParams: route.queryParams });
      if (!value.isLoggedIn) {
        setTimeout(() => {
          modalService.openModal(ModalName.SignIn, {
            activeTab: 'Sign Up',
            title: 'Sign Up',
            submitButton: 'Sign Up'
          });
        }, 200);
      }
      return false;
    })
  );
};
